import { render, staticRenderFns } from "./clipboard-document.vue?vue&type=template&id=517ad980&"
import script from "./clipboard-document.vue?vue&type=script&lang=js&"
export * from "./clipboard-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports